export default __webpack_public_path__ + "static/media/tesla.02fc1fb2.png";